import { configureStore } from "@reduxjs/toolkit";
import articleReducer from "./slices/articleSlice";
import authReducer from "./slices/authSlice";
import doctorReducer from "./slices/doctorSlice";
import clinicReducer from "./slices/clinicSlice";
import testimonialReducer from "./slices/testimonialSlice";
import managedserviceReducer from "./slices/managedserviceSlice";

import appointmentReducer from "./slices/appointmentSlice";

export const store = configureStore({
  reducer: {
    articles: articleReducer,
    auth: authReducer,
    clinic: clinicReducer,
    doctors: doctorReducer,
    managedservices: managedserviceReducer,
    appointments: appointmentReducer,
    testimonials: testimonialReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
